import { connection_platform } from "../services/api";

let gethostname = window.location.hostname;
let pathname = "";

let iplocal = connection_platform.ip_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

const urlIngWeb = `${connection_platform.type_connect}://${pathname}:${connection_platform.port_apache_view_extern}`;

export function handleFiles(fileUrl) {
  const newUrl = urlIngWeb + fileUrl;
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(newUrl, {
        method: "GET",
      });

      if (response.status === 404) {
        // Criar um objeto de erro personalizado para status 404
        const notFoundError = new Error("Arquivo não encontrado");
        notFoundError.status = 404;
        resolve(notFoundError);
      } else if (response.ok) {
        function bytesToMega(value) {
          if (value <= 1000000) {
            return Math.round(value / 1000) + "kb";
          } else {
            return Math.round(value / 1000 / 1024) + "mb";
          }
        }
        const fileInfo = {
          name: response.url.split("/").pop(),
          size: response.headers.get("Content-Length"),
          type: response.url.split("/").pop().split(".").pop(),
          typeMime: response.headers.get("Content-Type"),
        };

        resolve(fileInfo);
      } else {
        // Resolver a promessa com um valor que indica que a solicitação falhou
        resolve(null);
      }
    } catch (error) {
      // Resolver a promessa com um valor que indica que a solicitação falhou
      resolve(null);
    }
  });
}
